<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   width="24"
   height="24"
   viewBox="0 0 24 24"
   fill="none"
   version="1.1"
   id="svg1"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs1" />
  <path
     d="m 5.8043497,3.4268235 c 2.52225,1.89355 5.2350703,5.73305 6.2312303,7.7933105 0.99616,-2.0602605 3.70898,-5.8997605 6.23123,-7.7933105 1.81992,-1.36632 4.76877,-2.42349 4.76877,0.9405 0,0.67185 -0.38519,5.6438105 -0.61112,6.4510705 -0.7853,2.806279 -3.64685,3.522059 -6.19234,3.088829 4.44938,0.75726 5.58122,3.26557 3.13678,5.77388 -4.64246,4.76378 -6.67251,-1.19524 -7.19268,-2.72215 -0.0954,-0.27992 -0.13998,-0.41087 -0.14064,-0.29952 -6.6e-4,-0.11135 -0.0453,0.0196 -0.14064,0.29952 -0.52017,1.52691 -2.5502203,7.48593 -7.1926803,2.72215 -2.44444,-2.50831 -1.3126,-5.01662 3.13678,-5.77388 -2.54549,0.43323 -5.40704,-0.28255 -6.19234,-3.088829 -0.22593,-0.80726 -0.61112,-5.7792205 -0.61112,-6.4510705 0,-3.36399 2.94885,-2.30682 4.76877,-0.9405 z"
     fill="currentColor"
     id="path1"
     style="stroke-width:0.0387324" />
</svg>
